<script lang="ts">
    import { AppError, AclibError } from 'portlet/common/errors';

    import AclibErrorComponent from './errors/AclibError.svelte';
    import DefaultError from './errors/DefaultError.svelte';

    interface Props {
        error: AppError;
    }

    let { error }: Props = $props();

    function getErrorComponent() {
        return error instanceof AclibError ? AclibErrorComponent : DefaultError;
    }

    const SvelteComponent = $derived(getErrorComponent());
</script>

<SvelteComponent {error} />
